import LegalInformation from './LegalInformation';

export default LegalInformation;